/**
 * Created by Fernando Torres on 01/02/2018.
 */
import UsersListView from '@/views/app/users/users-list-view'
import UsersCreateView from '@/views/app/users/users-create-view'
import UsersEditView from '@/views/app/users/users-edit-view'
import UsersGuards from '@/guards/users.guards'

export default [
  {
    path: 'users',
    name: 'users',
    component: UsersListView
  },
  {
    path: 'users/create',
    name: 'users-create',
    component: UsersCreateView,
    beforeEnter: UsersGuards.onCreate
  },
  {
    path: 'users/:id',
    name: 'users-edit',
    component: UsersEditView,
    beforeEnter: UsersGuards.onEdit
  }
]



// WEBPACK FOOTER //
// ./src/router/app/users/index.js